import React from 'react';
import logo from '../../assets/icons/agroland_logo.png';

const Spinner = ({ className }) => (
    <div className={`${className} rounded-full border-4 border-[#147F26]/20 border-t-[#147F26] animate-spin`} role="status" />
);

const Loading = ({ size = 'full' }) => {
    if (size === 'sm') {
        return (
            <div className="w-full flex items-center justify-center py-6">
                <Spinner className="w-10 h-10" />
            </div>
        );
    }
    return (
        <div className="w-full min-h-[45vh] flex flex-col items-center justify-center gap-5 animate-loaderIn" role="status">
            <img src={logo} alt="Agroland" className="h-12 w-auto animate-loaderPulse" />
            <div className="w-28 h-1 rounded-full bg-[#147F26]/15 dark:bg-white/10 overflow-hidden">
                <div className="h-full w-1/3 rounded-full bg-[#147F26] animate-loaderBar" />
            </div>
        </div>
    );
};

export default Loading;
